// Timeline animations and scrollbar styles
export const timelineStyles = `
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
  @keyframes ping {
    75%, 100% {
      transform: scale(2);
      opacity: 0;
    }
  }
  @keyframes soft-pulse {
    0% {
      transform: scale(1);
      opacity: 0.8;
    }
    100% {
      transform: scale(2.5);
      opacity: 0;
    }
  }
  @keyframes soft-pulse-slow {
    0% {
      transform: scale(1);
      opacity: 0.6;
    }
    100% {
      transform: scale(2.2);
      opacity: 0;
    }
  }
  .animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
  .animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }
  .animate-soft-pulse {
    animation: soft-pulse 2.5s cubic-bezier(0, 0, 0.2, 1) infinite;
  }
  .animate-soft-pulse-slow {
    animation: soft-pulse-slow 4s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  /* Custom Scrollbar Styles - Cross Browser */
  
  /* WebKit browsers (Chrome, Safari, Edge) */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    -webkit-appearance: none;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
    border: none;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #3b82f6 0%, #ef4444 100%) !important;
    border-radius: 10px !important;
    border: 2px solid transparent !important;
    background-clip: content-box !important;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    -webkit-border-radius: 10px;
    -webkit-background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #2563eb 0%, #dc2626 100%);
    transform: scale(1.1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  /* Safari specific overrides */
  @supports (-webkit-backdrop-filter: none) {
    ::-webkit-scrollbar {
      width: 8px !important;
      height: 8px !important;
    }
    
    ::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #3b82f6 0%, #ef4444 100%) !important;
      border-radius: 10px !important;
      border: 2px solid transparent !important;
      background-clip: content-box !important;
      -webkit-background-clip: content-box !important;
      -webkit-appearance: none !important;
    }
    
    ::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(135deg, #2563eb 0%, #dc2626 100%) !important;
    }
  }

  /* Dark mode scrollbar */
  .dark ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #60a5fa 0%, #f87171 100%);
  }

  .dark ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #3b82f6 0%, #ef4444 100%);
  }

  /* Firefox scrollbar */
  * {
    scrollbar-width: thin;
    scrollbar-color: #3b82f6 transparent;
  }

  .dark * {
    scrollbar-color: #60a5fa transparent;
  }

  /* Custom scrollbar for specific elements */
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    -webkit-appearance: none;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    border: none;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    border-radius: 8px;
    border: 1px solid transparent;
    background-clip: content-box;
    -webkit-background-clip: content-box;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #e91e63 0%, #ff5722 100%);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    transform: scale(1.05);
  }

  .dark .custom-scrollbar::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
  }

  .dark .custom-scrollbar::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #ec4899 0%, #ef4444 100%);
  }

  .dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #db2777 0%, #dc2626 100%);
  }

  /* Timeline specific scrollbar */
  .timeline-scrollbar::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    -webkit-appearance: none;
  }

  .timeline-scrollbar::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.02);
    border-radius: 6px;
    border: none;
  }

  .timeline-scrollbar::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-radius: 6px;
    border: 1px solid transparent;
    background-clip: content-box;
    -webkit-background-clip: content-box;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  .timeline-scrollbar::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transform: scale(1.1);
  }

  .dark .timeline-scrollbar::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.02);
  }

  .dark .timeline-scrollbar::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
  }

  .dark .timeline-scrollbar::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  }

  /* Modal scrollbar */
  .modal-scrollbar::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    -webkit-appearance: none;
  }

  .modal-scrollbar::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.03);
    border-radius: 10px;
    border: none;
  }

  .modal-scrollbar::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
    border-radius: 10px;
    border: 2px solid transparent;
    background-clip: content-box;
    -webkit-background-clip: content-box;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  .modal-scrollbar::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transform: scale(1.1);
  }

  .dark .modal-scrollbar::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.03);
  }

  .dark .modal-scrollbar::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  }

  .dark .modal-scrollbar::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  }

  /* Force scrollbar styling in Safari */
  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    ::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 8px;
      height: 8px;
    }
    
    ::-webkit-scrollbar-thumb {
      -webkit-appearance: none;
      background: linear-gradient(135deg, #3b82f6 0%, #ef4444 100%);
      border-radius: 10px;
      border: 2px solid transparent;
      background-clip: content-box;
      -webkit-background-clip: content-box;
    }
    
    .custom-scrollbar::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 6px;
      height: 6px;
    }
    
    .timeline-scrollbar::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 4px;
      height: 4px;
    }
    
    .modal-scrollbar::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 8px;
      height: 8px;
    }
  }

  /* Additional Safari-specific rules */
  @supports (-webkit-touch-callout: none) {
    ::-webkit-scrollbar {
      width: 8px !important;
      height: 8px !important;
      -webkit-appearance: none !important;
    }
    
    ::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #3b82f6 0%, #ef4444 100%) !important;
      border-radius: 10px !important;
      border: 2px solid transparent !important;
      background-clip: content-box !important;
      -webkit-background-clip: content-box !important;
      -webkit-appearance: none !important;
    }
    
    .custom-scrollbar::-webkit-scrollbar {
      width: 6px !important;
      height: 6px !important;
      -webkit-appearance: none !important;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;
      border-radius: 8px !important;
      border: 1px solid transparent !important;
      background-clip: content-box !important;
      -webkit-background-clip: content-box !important;
    }
    
    .timeline-scrollbar::-webkit-scrollbar {
      width: 4px !important;
      height: 4px !important;
      -webkit-appearance: none !important;
    }
    
    .timeline-scrollbar::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
      border-radius: 6px !important;
      border: 1px solid transparent !important;
      background-clip: content-box !important;
      -webkit-background-clip: content-box !important;
    }
    
    .modal-scrollbar::-webkit-scrollbar {
      width: 8px !important;
      height: 8px !important;
      -webkit-appearance: none !important;
    }
    
    .modal-scrollbar::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
      border-radius: 10px !important;
      border: 2px solid transparent !important;
      background-clip: content-box !important;
      -webkit-background-clip: content-box !important;
    }
  }

  /* Modal open/close animation */
  @keyframes modal-in {
    0% { opacity: 0; transform: scale(0.96) translateY(40px); }
    100% { opacity: 1; transform: scale(1) translateY(0); }
  }
  @keyframes modal-out {
    0% { opacity: 1; transform: scale(1) translateY(0); }
    100% { opacity: 0; transform: scale(0.96) translateY(40px); }
  }
`; 